import { getDemoData } from './helpers';

export const maskDemoField = (isDemo, key, value) => {
  if (!isDemo) return value;
  const demoValue = getDemoData(key);
  return demoValue !== '' ? demoValue : value;
};

const BREADCRUMB_LABEL_MASK_KEYS = {
  buildingName: 'building-name',
  applicationName: 'tenant-name',
  policyName: 'tenant-name',
  flaggedCancellationName: 'tenant-name',
  claimName: 'tenant-name',
  landlordName: 'landlord-name',
  invoiceLabel: 'invoice-number',
  userName: 'username',
  emailLabel: 'username',
  notificationLabel: 'username',
};

/** Masks entity names in breadcrumb trails when demo mode is on. */
export const maskBreadcrumbLabels = (labels, isDemo) => {
  if (!isDemo || !labels) return labels;

  return Object.entries(labels).reduce((masked, [key, value]) => {
    if (value == null || value === '') {
      masked[key] = value;
      return masked;
    }

    const maskKey = BREADCRUMB_LABEL_MASK_KEYS[key];
    masked[key] = maskKey ? maskDemoField(true, maskKey, value) : value;
    return masked;
  }, {});
};

export const buildMaskedUserBuildingRow = (building, isDemo, rowIndex) => [
  maskDemoField(isDemo, 'building-name', building.name),
  building.building_type,
  maskDemoField(isDemo, 'phone', building.phone),
  maskDemoField(isDemo, 'address-street', building.billingStreet),
  maskDemoField(isDemo, 'email', building.email_address),
  building.student_housing,
  rowIndex,
];

export const buildMaskedInvitationEmailRow = (email, isDemo, rowIndex) => [
  email.request_type,
  maskDemoField(isDemo, 'email', email.accepter_email),
  maskDemoField(isDemo, 'email', email.requestor_email),
  maskDemoField(isDemo, 'username', email.requestor ? email.requestor.username : ''),
  email.property.length,
  new Date(email.updatedAt).toISOString().slice(0, 10),
  email.request_status,
  email.accepter_role,
  email.requestor_role,
  {
    id: email.id,
    request_status: email.request_status,
  },
  email.id,
];

export const buildMaskedNotificationMessageRow = (message, isDemo) => [
  message.request_type,
  message.request_status,
  maskDemoField(isDemo, 'email', message.requestor_email),
  message.requestor_role,
  maskDemoField(isDemo, 'email', message.accepter_email),
  message.accepter_role,
  message.property?.length ?? 0,
  new Date(message.updatedAt).toISOString().slice(0, 10),
  message.id,
  message,
];

export const buildMaskedInvoiceLineRow = (invoice, disputeReason, isDemo) => [
  invoice.flg,
  invoice.ServiceDate ? invoice.ServiceDate : '',
  maskDemoField(isDemo, 'invoice-description', invoice.Description || ''),
  invoice.Amount ? invoice.Amount : '',
  disputeReason,
  // Keep the raw description for policy drill-down (legacy invoice modal parity).
  invoice.Description || '',
];

export const buildMaskedDisputeHistoryRow = (dispute, formatDate, isDemo) => [
  dispute.line_id || '',
  formatDate(dispute.service_date),
  maskDemoField(isDemo, 'invoice-description', dispute.description || ''),
  dispute.amount ?? '',
  dispute.reason || '',
  formatDate(dispute.dispute_date),
];

export const buildMaskedOutgoingNotificationRow = (message, isDemo) => [
  message.request_type,
  message.request_status,
  maskDemoField(isDemo, 'email', message.accepter_email),
  message.accepter_role,
  maskDemoField(isDemo, 'email', message.requestor_email),
  message.requestor_role,
  maskDemoField(isDemo, 'invoice-description', message.email_text),
  message.property?.length ?? 0,
  new Date(message.updatedAt).toISOString().slice(0, 10),
  message.id,
  message,
];

export const buildMaskedEmailDetailBuildingRow = (building, isDemo) => [
  maskDemoField(isDemo, 'building-name', building.name),
  building.building_type,
  maskDemoField(isDemo, 'phone', building.phone),
  maskDemoField(isDemo, 'address-street', building.billingStreet),
  maskDemoField(isDemo, 'email', building.email_address),
  building.total_of_units,
  building.student_housing,
  building.id,
];
